import React from 'react';
import { HeaderIcon, IconCart } from '@banhala/ui-kit';
import { useNavigator } from 'shared/src/utils';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getCartMeta } from 'shared/src/api';
import { queryKey } from 'shared/src/constant';
import { useLogMarketAnalyticsEvent } from '../../hooks/useLogMarketAnalyticsEvent';

type CartIconProps = { headerStyle: 'transparent' | 'white' };
export const CartIcon: React.FC<CartIconProps> = props => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();
  const { navigator } = useNavigator();
  return (
    <React.Suspense
      fallback={
        <HeaderIcon
          onPress={() => {
            logMarketAnalytics({
              name: 'CLICK_CART',
              analytics: {
                LANDING_FROM: 'CARTICON',
              },
            });
            navigator.moveToWebview('Cart');
          }}
          backgroundColor={props.headerStyle}
        >
          <IconCart />
        </HeaderIcon>
      }
    >
      <CartIconInternal {...props} />
    </React.Suspense>
  );
};

const CartIconInternal: React.FC<CartIconProps> = props => {
  const { data: cartsCount } = useSuspenseQuery({
    queryKey: queryKey.cartMeta,
    queryFn: getCartMeta,
    select: data => data.data.carts_count,
  });
  const logMarketAnalytics = useLogMarketAnalyticsEvent();
  const { navigator } = useNavigator();
  return (
    <HeaderIcon
      onPress={() => {
        logMarketAnalytics({
          name: 'CLICK_CART',
          analytics: {
            LANDING_FROM: 'CARTICON',
          },
        });
        navigator.moveToWebview('Cart');
      }}
      badgeNum={cartsCount ?? 0}
      backgroundColor={props.headerStyle}
    >
      <IconCart />
    </HeaderIcon>
  );
};
